import * as React from 'react'

import { SortButton } from '~/client/src/shared/components/Filters/triggers'
import { SortByPopover } from '~/client/src/shared/components/OptionsList'
import SortOrder from '~/client/src/shared/enums/SortOrder'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import { useResourceFieldContext } from '../ResourceFieldContext'

function DefaultSort(): JSX.Element {
  const {
    sortKey,
    sortOrder,
    activePopup,
    sortOptions,
    setSortDefaults,
    closePopup,
    togglePopup,
  } = useResourceFieldContext()

  const isOpen = activePopup === 'sort'

  const handleOpenChange = React.useCallback(
    (open: boolean) => {
      if (!open) closePopup()
    },
    [closePopup],
  )

  const handleSortKeyChange = React.useCallback(
    (key: string | null) => {
      setSortDefaults(key, sortOrder)
    },
    [setSortDefaults, sortOrder],
  )

  const handleSortOrderChange = React.useCallback(
    (order: SortOrder) => {
      setSortDefaults(sortKey, order)
    },
    [setSortDefaults, sortKey],
  )

  const handleReset = React.useCallback(() => {
    setSortDefaults(null, SortOrder.ASC)
  }, [setSortDefaults])

  const triggerLabel = React.useMemo(() => {
    const base = Localization.translator.sort
    const selected = sortKey
      ? sortOptions.find(o => o.key === sortKey)?.label
      : null
    if (!selected) return base
    const orderText =
      sortOrder === SortOrder.ASC
        ? Localization.translator.ascending
        : Localization.translator.descending
    return `${base}: ${selected} - ${orderText}`
  }, [sortKey, sortOrder, sortOptions])

  return (
    <SortByPopover
      open={isOpen}
      onOpenChange={handleOpenChange}
      side="right"
      options={sortOptions}
      selectedKey={sortKey}
      sortOrder={sortOrder}
      onChange={handleSortKeyChange}
      onSortOrderChange={handleSortOrderChange}
      onReset={handleReset}
    >
      <SortButton label={triggerLabel} onClick={() => togglePopup('sort')} />
    </SortByPopover>
  )
}

export default DefaultSort
